export default __webpack_public_path__ + "static/typography-image-g-8c6510059170b6959ad26d2ea577646ab0997af92c0d0cd79145072ce2b3fdae.png";